import { createClient } from '@exodus/auth-client-base'
import { signAttached } from '@exodus/crypto/ed25519'
import pDefer from 'p-defer'

class ABTestingClient {
  #client
  #logger
  #authenticated

  constructor({ apiUrl, logger }) {
    this.apiUrl = apiUrl

    this.#client = null
    this.#logger = logger
    this.#authenticated = pDefer()
  }

  authenticate({ publicKey, privateKey } = {}, metadata) {
    privateKey = Buffer.from(privateKey, 'hex').subarray(0, 32)
    const keyPair = {
      publicKey,
      sign: async (message) => signAttached({ message, privateKey, format: 'buffer' }),
    }

    this.#client = createClient({
      config: {
        keyPair,
        baseUrl: this.apiUrl,
        authTokenUrl: `${this.apiUrl}/auth/token`,
        authChallengeUrl: `${this.apiUrl}/auth/challenge`,
      },
      metadata,
    })

    this.#authenticated.resolve()
  }

  async getExperiments() {
    await this.#authenticated.promise

    try {
      const { experiments } = await this.#client.get('experiments', { auth: true })
      return { value: experiments }
    } catch (error) {
      this.#logger.warn('failed to request experiments')
      throw error
    }
  }

  async getVariants() {
    await this.#authenticated.promise

    try {
      const { variants } = await this.#client.get('variants', { auth: true })
      return { value: variants }
    } catch (error) {
      this.#logger.warn('failed to request variants')
      throw error
    }
  }

  async trackEvent({ experimentId, variant, type, value, unique, strategy, timestampResolution }) {
    await this.#authenticated.promise

    try {
      const data = { experimentId, variant, type, value, unique, strategy, timestampResolution }
      await this.#client.post('events', { auth: true, data })
    } catch {
      this.#logger.warn('failed to track event')
    }
  }
}

export default ABTestingClient
